package com.imobly.imobly.api.httpclient

import com.imobly.imobly.api.dto.viacep.ErrorViaCepDTO
import com.imobly.imobly.api.dto.viacep.ResponseMessageViaCep
import com.imobly.imobly.api.dto.viacep.ViaCepDTO
import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.request.get
import io.ktor.http.isSuccess
import kotlinx.serialization.json.Json

class ViaCepHttpClient(val httpClient: HttpClient) {

    val json = Json {
        encodeDefaults = true
        explicitNulls = false
    }

    suspend fun getAddress(cep: String): ResponseMessageViaCep  {
        val response = httpClient.get("/ws/$cep/json")
        val address = response.body<ViaCepDTO>()
        return if (!address.erro) address else ErrorViaCepDTO("CEP não encontrado")
    }
}
